import pug from 'javascripts/core_post_webpack/sitewide_business_elements/bookmarks/templates/modal_view.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/bookmarks/templates/modal_view'
] = pug;
